import { useFormik } from "formik";
import axios from "axios";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import Layout from "../assets/component/Layout";
import { useNavigate } from "react-router-dom";

export const BASE_URL = process.env.REACT_APP_API_URL;

export default function EventRegistrationForm() {
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            participantName: "",
            rollNumber: "",
            eventName: "",
            contactNumber: "",
            teamName: "",
            dietaryPreferences: "",
            emergencyContact: "",
        },
        onSubmit: async (values) => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.post(`${BASE_URL}create-event`, values, {
                    headers: { Authorization: token },
                });

                if (response.status === 200) {
                    navigate("/engineers-forms");
                }
            } catch (error) {
                console.error("Submission error:", error);
            }
        },
    });

    return (
        <Layout>
            <section className="Inner-page-layout">
                <div>
                    <h1>Event Registration Form</h1>
                    <div className="application-forms-cards">
                        <Container>
                            <Form onSubmit={formik.handleSubmit}>
                                <Row>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Participant Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="participantName"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.participantName}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Roll Number/Employee ID</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="rollNumber"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.rollNumber}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Event Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="eventName"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.eventName}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Contact Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="contactNumber"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.contactNumber}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Team Name (if team event)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="teamName"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.teamName}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Dietary Preferences (if food included)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="dietaryPreferences"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.dietaryPreferences}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Emergency Contact</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="emergencyContact"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.emergencyContact}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="text-center mt-3">
                                    <Button type="submit">Save</Button>
                                </div>
                            </Form>
                        </Container>
                    </div>
                </div>
            </section>
        </Layout>
    );
}
